import { useCallback } from "react";
import * as ReactQuery from "react-query";

export function useMutation<TData, TError, TVariables>(
  // eslint-disable-next-line no-warning-comments
  // TODO: find a way to make the primary key really unique & optional keys to be dynamic
  // https://react-query.tanstack.com/guides/query-keys#query-keys-are-hashed-deterministically
  // https://react-query.tanstack.com/guides/query-keys#if-your-query-function-depends-on-a-variable-include-it-in-your-query-key
  [primaryKey, ...optionalKeys]: [string, ...string[]],
  {
    mutationFn,
    ...options
  }: Required<
    Pick<
      ReactQuery.MutationOptions<TData, TError, TVariables, unknown>,
      "mutationFn" | "onSuccess" | "onError" | "retry"
    >
  >
) {
  const mutation = ReactQuery.useMutation(
    [primaryKey, ...optionalKeys],
    mutationFn,
    options
  );

  // Strip second param from `mutate` to simplify types and configure mutation only in `useMutation` options
  const mutate = useCallback(
    (param: Parameters<typeof mutation.mutate>[0]) => mutation.mutate(param),
    [mutation]
  );

  // Strip second param from `mutateAsync` to simplify types and configure mutation only in `useMutation` options
  const mutateAsync = useCallback(
    (param: Parameters<typeof mutation.mutateAsync>[0]) =>
      mutation.mutateAsync(param),
    [mutation]
  );

  return {
    error: mutation.error,
    data: mutation.data,
    status: mutation.status,
    reset: mutation.reset,
    mutate,
    mutateAsync,
  };
}

export type UseMutationReturnType = ReturnType<typeof useMutation>;
